import React, { useEffect, useState } from 'react'
import { Link as RouterLink, useParams } from 'react-router-dom';
import { trackActivity } from '../../../../utils/mixpanel';
import { globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { getCalenderDetailApi } from '../apiService';
import { PageLoader } from '../../../../shared_elements';
import { Box, Checkbox, Divider, FormGroup, Grid, IconButton, Link, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material';
import SettingNav from '../../../elements/SettingNav';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import HolidayRules from '../components/HolidayRules';
import Holiday from '../components/Holiday';
import { fieldDateFormat } from '../../../../constants';
import moment from 'moment';


const CalenderDetails = () => {
    const params = useParams();
    const [calenderDetail, setCalenderDetail] = useState({})
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getCalenderDetails();
        trackActivity("Page Viewed", { page_title: "Calendar Detail Page" });
    }, []);

    const getCalenderDetails = () => {
        setLoading(true);
        globalGetService(getCalenderDetailApi(params))
            .then(response => {
                if (checkApiStatus(response)) {
                    setCalenderDetail(response.data.data);
                    setLoading(false);
                }
                setLoading(false);
            })
    }

    return (
        <Paper className="setting_details_section lease-details-section">
            <SettingNav />
            <div className="lease-details-content" style={{ padding: '0px 10px 0px 0px' }}>
                <Paper square className="responsive-paper" sx={{ mt: 0, '@media (min-width:768px) and (orientation: portrait)': { mt: '30px', }, }}>
                    <Box>
                        <Stack
                            direction="row"
                            divider={<Divider orientation="vertical" flexItem />}
                            spacing={2}
                        >
                            <Box style={{ width: '40%', marginTop:"4px" }}>
                                <Link component={RouterLink} to="/settings/calendar" sx={{ display: "flex", alignItems: "center", fontFamily: "Roboto", textDecoration: "none", cursor: "pointer", marginLeft: "-4px" }} >
                                    <ArrowCircleLeftOutlinedIcon />
                                    <Typography sx={{ fontSize: "13px", fontWeight: "bold", paddingLeft: "5px", textDecoration: "underline", }} >
                                        Calendar List
                                    </Typography>
                                </Link>                        
                                <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <TextField
                                            disabled
                                            id="name"
                                            label="Name"
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            value={calenderDetail?.name || ''}
                                            fullWidth
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <TextField
                                            disabled
                                            id="effective_from"
                                            label="Effective From"
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            value={calenderDetail?.effective_from ? moment(calenderDetail.effective_from).format(fieldDateFormat) : ''}
                                            fullWidth
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <TextField
                                            disabled
                                            id="effective_till"
                                            label="Effective Till"
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            value={calenderDetail?.effective_till ? moment(calenderDetail.effective_till).format(fieldDateFormat) : ''}
                                            fullWidth
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <TextField
                                            disabled
                                            id="status"
                                            label="Status"
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            value={calenderDetail?.status?.label || ''}
                                            fullWidth
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <TextField
                                            disabled
                                            id="remarks"
                                            label="Remarks"
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            value={calenderDetail?.remarks || ''}
                                            fullWidth
                                            multiline
                                            rows={3}
                                        />
                                    </Grid>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <Typography className='section-header-text'>Business Week Day’s</Typography>
                                        <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', ml: '-10px' }}>
                                            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => (
                                                <Box key={day} className="check-item-div">
                                                    <Checkbox
                                                        disabled
                                                        size="small"
                                                        checked={Boolean(calenderDetail?.business_week_days?.[day])}
                                                    />
                                                    <span className="check-item-span file-name">{day}</span>
                                                </Box>
                                            ))}
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box style={{ width: '60%' }}>
                                <Holiday calenderSlug={calenderDetail?.slug} calenderDetail={calenderDetail} />
                            </Box>
                        </Stack>
                    </Box>
                    <Box>
                        <HolidayRules calenderDetail={calenderDetail} calenderSlug={calenderDetail?.slug}/>
                    </Box>
                </Paper>
            </div>
            {isLoading ? <PageLoader /> : null}
        </Paper>

    )
}

export default CalenderDetails